import type { Job, SalaryPeriod, JobRemote } from "./types";

/** Fecha corta DD/MM/AAAA, la convención de fechas del proyecto. */
export function fmtDate(sec: number | null | undefined): string {
  if (!sec) return "—";
  const d = new Date(sec * 1000);
  return `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}/${d.getFullYear()}`;
}

/** Valor para un <input type="date"> (AAAA-MM-DD, hora local). */
export function toDateInput(sec: number | null | undefined): string {
  if (!sec) return "";
  const d = new Date(sec * 1000);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

/**
 * Convierte un <input type="date"> a segundos unix, fijando el FINAL del
 * día elegido: si el reclutador pone el 30, la oferta debe seguir viva
 * durante todo el 30, no morir a las 00:00 de esa madrugada.
 */
export function fromDateInput(value: string): number | null {
  if (!value) return null;
  const [y, m, d] = value.split("-").map((n) => parseInt(n, 10));
  if (!y || !m || !d) return null;
  return Math.floor(new Date(y, m - 1, d, 23, 59, 59).getTime() / 1000);
}

/** Días que faltan para la caducidad (negativo = ya caducó). */
export function daysUntil(sec: number | null | undefined): number {
  if (!sec) return 0;
  return Math.ceil((sec * 1000 - Date.now()) / 86400000);
}

const PERIOD_LABEL: Record<SalaryPeriod, string> = {
  year: "/año",
  month: "/mes",
  hour: "/hora",
};

export const REMOTE_LABEL: Record<JobRemote, string> = {
  onsite: "Presencial",
  hybrid: "Híbrido",
  remote: "En remoto",
};

/** "35.000 – 45.000 € /año", "Desde 40.000 € /año", o null si no hay banda. */
export function fmtSalary(j: Pick<Job, "salaryMin" | "salaryMax" | "salaryCurrency" | "salaryPeriod">): string | null {
  const { salaryMin: lo, salaryMax: hi, salaryCurrency: cur, salaryPeriod: per } = j;
  if (lo == null && hi == null) return null;
  const n = (v: number) => v.toLocaleString("es-ES");
  const unit = `${cur === "EUR" ? "€" : cur} ${PERIOD_LABEL[per]}`;
  if (lo != null && hi != null) return `${n(lo)} – ${n(hi)} ${unit}`;
  if (lo != null) return `Desde ${n(lo)} ${unit}`;
  return `Hasta ${n(hi!)} ${unit}`;
}

export function fmtBytes(n: number | null | undefined): string {
  if (!n) return "—";
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${Math.round(n / 1024)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
}
